import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExportUserReport($customerId: ID!) {
    exportUserReport(customerId: $customerId) {
      filename
      content
    }
  }
`;

export const exportUserReport = (customerId) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId },
  }).then(({ data }) => getSingleProp(data));
